import { render, staticRenderFns } from "./PromotionDappFreebieLimitPerOrder.vue?vue&type=template&id=81d3ccc4&scoped=true&"
import script from "./PromotionDappFreebieLimitPerOrder.vue?vue&type=script&lang=js&"
export * from "./PromotionDappFreebieLimitPerOrder.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappFreebieLimitPerOrder.vue?vue&type=style&index=0&id=81d3ccc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3ccc4",
  null
  
)

export default component.exports